module.exports = __webpack_public_path__ + "static/media/covid1.97afea1a.jpg";